import { IDataDownloadSettingsDTO, IJobsDownloadTemplate } from 'wisestep-api';

export const fieldsAvailable: fieldsAvailableType[] = [
  'Candidate Name',
  'Candidate Email',
  'Candidate Phone',
  'LinkedIn URL',
  'Source',
  'Tags',
  'Current Country',
  'Current Continent',
  'Current Location',
  'Nationality',
  'Work Authorisation',
  'Work Authorisation Details',
  'Current Salary',
  'Expected Salary',
  'Current Job Title',
  'Current Employer',
  'Current Job Type',
  'Previous Job Title',
  'Previous Employers',
  'Experience',
  'Notice Period',
  'Mapped Job Title',
  'Job Type',
  'Wisestep Job Code',
  'Client Job Code',
  'Job Location',
  'Job Location Country',
  'Job Posted Date',
  'Job Tag',
  'Job Account Manager Name',
  'Job Account Manager Email',
  'Client Name',
  'Client Recruiter Name',
  'Job Admin Recruiter Email',
  // 'Job Admin Team Name',
  'Recruiter Name',
  'Recruiter Email',
  'Team',
  'Notes',
  'Stage Status',
  'Submitted Date',
  'Stage',
  'Stage Date',
  'Latest Stage Update Date',
  // 'Resume Location',
  'Job Preference Permanent',
  'Job Preference Contract',
  'General Note',
  // 'Candidate ID',
  'Passport Type',
  'Passport Number',
  'Postal Address',
  'SSN Number',
  'Gender',
  'Age',
  'Visa Type',
  'Highest Education',
  'Certifications',
  'Date Of Birth',
  'Expected Allowances & Benefits',
  'Aadhar Number',
  'PAN Card',
  'Willing to Relocate',
  'Current Job Include Travel',
  'Other Interview Stage',
  'Family Willing To Relocate',
  'Your Assessment',
  'Interviewing Anywhere Else',
  'Reason For Change',
  'Available Time Slot',
  'Communication Preferences',
  'Relocation Preferences',
  'Preferred Location',
  'Institutes Attended',
  'Total Experience',
  'Skills',
  'Alternate Phone Number',
  'Alternate Email',
  'Visa Validity',
  'Messenger ID',
  'Joining Date',
];
export const defValues: IDataDownloadSettingsDTO = {
  id: '',
  dataType: 'CandidateCRM',
  recruiterId: '',
  workspaceId: '',
  allowedColumns: [],
  isAdmin: false,
  recordsDownloadLimit: 2000,
  downloadCcEmail: '',
};

export const defaultValues: IJobsDownloadTemplate = {
  id: '',
  dataType: 'CRM',
  recruiterId: '',
  workspaceId: '',
  allowedColumns: [],
  isAdmin: false,
  recordsDownloadLimit: 2000,
  downloadCcEmail: '',
  name: '',
  isFavorite: false,
  isHidden: false,
};
export const fieldsObject = {
  'Candidate Name': false,
  'Candidate Email': false,
  'Candidate Phone': false,
  'LinkedIn URL': false,
  Source: false,
  Tags: false,
  'Current Country': false,
  'Current Continent': false,
  'Current Location': false,
  Nationality: false,
  'Work Authorisation': false,
  'Work Authorisation Details': false,
  'Current Salary': false,
  'Expected Salary': false,
  'Current Job Title': false,
  'Current Employer': false,
  'Current Job Type': false,
  'Previous Job Title': false,
  'Previous Employers': false,
  Experience: false,
  'Notice Period': false,
  'Mapped Job Title': false,
  'Job Type': false,
  'Wisestep Job Code': false,
  'Client Job Code': false,
  'Job Location': false,
  'Job Location Country': false,
  'Job Posted Date': false,
  'Job Tag': false,
  'Job Account Manager Name': false,
  'Job Account Manager Email': false,
  'Client Name': false,
  'Client Recruiter Name': false,
  'Job Admin Recruiter Email': false,
  // 'Job Admin Team Name': false,
  'Recruiter Name': false,
  'Recruiter Email': false,
  Team: false,
  Notes: false,
  'Stage Status': false,
  'Submitted Date': false,
  Stage: false,
  'Stage Date': false,
  'Latest Stage Update Date': false,
  // 'Resume Location': false,
  'Job Preference Permanent': false,
  'Job Preference Contract': false,
  'General Note': false,
  // 'Candidate ID': false,
  'Passport Type': false,
  'Passport Number': false,
  'Postal Address': false,
  'SSN Number': false,
  Gender: false,
  Age: false,
  'Visa Type': false,
  'Highest Education': false,
  Certifications: false,
  'Date Of Birth': false,
  'Expected Allowances & Benefits': false,
  'Aadhar Number': false,
  'PAN Card': false,
  'Willing to Relocate': false,
  'Current Job Include Travel': false,
  'Other Interview Stage': false,
  'Family Willing To Relocate': false,
  'Your Assessment': false,
  'Interviewing Anywhere Else': false,
  'Reason For Change': false,
  'Available Time Slot': false,
  'Communication Preferences': false,
  'Relocation Preferences': false,
  'Preferred Location': false,
  'Institutes Attended': false,
  'Total Experience': false,
  Skills: false,
  'Alternate Phone Number': false,
  'Alternate Email': false,
  'Visa Validity': false,
  'Messenger ID': false,
  'Joining Date': false,
};
export type fieldsAvailableType =
  | 'Candidate Name'
  | 'Candidate Email'
  | 'Candidate Phone'
  | 'LinkedIn URL'
  | 'Source'
  | 'Tags'
  | 'Current Country'
  | 'Current Continent'
  | 'Current Location'
  | 'Nationality'
  | 'Work Authorisation'
  | 'Work Authorisation Details'
  | 'Current Salary'
  | 'Expected Salary'
  | 'Current Job Title'
  | 'Current Employer'
  | 'Current Job Type'
  | 'Previous Job Title'
  | 'Previous Employers'
  | 'Experience'
  | 'Notice Period'
  | 'Mapped Job Title'
  | 'Job Type'
  | 'Wisestep Job Code'
  | 'Client Job Code'
  | 'Job Location'
  | 'Job Location Country'
  | 'Job Posted Date'
  | 'Job Tag'
  | 'Job Account Manager Name'
  | 'Job Account Manager Email'
  | 'Client Name'
  | 'Client Recruiter Name'
  | 'Job Admin Recruiter Email'
  // | 'Job Admin Team Name'
  | 'Recruiter Name'
  | 'Recruiter Email'
  | 'Team'
  | 'Notes'
  | 'Stage Status'
  | 'Submitted Date'
  | 'Stage'
  | 'Stage Date'
  | 'Latest Stage Update Date'
  // | 'Resume Location'
  | 'Job Preference Permanent'
  | 'Job Preference Contract'
  | 'General Note'
  // | 'Candidate ID'
  | 'Passport Type'
  | 'Passport Number'
  | 'Postal Address'
  | 'SSN Number'
  | 'Gender'
  | 'Age'
  | 'Visa Type'
  | 'Highest Education'
  | 'Certifications'
  | 'Date Of Birth'
  | 'Expected Allowances & Benefits'
  | 'Aadhar Number'
  | 'PAN Card'
  | 'Willing to Relocate'
  | 'Current Job Include Travel'
  | 'Other Interview Stage'
  | 'Family Willing To Relocate'
  | 'Your Assessment'
  | 'Interviewing Anywhere Else'
  | 'Reason For Change'
  | 'Available Time Slot'
  | 'Communication Preferences'
  | 'Relocation Preferences'
  | 'Preferred Location'
  | 'Institutes Attended'
  | 'Total Experience'
  | 'Skills'
  | 'Alternate Phone Number'
  | 'Alternate Email'
  | 'Visa Validity'
  | 'Messenger ID'
  | 'Joining Date';
